import styled from 'styled-components'

export const DetailArticle = styled.article`
    width: 100%;
`;

export const DetailTopbar = styled.div`
    margin-bottom: clamp(44px, 7vw, 76px);
`;

export const BackButton = styled.button.attrs({ type: 'button' })`
    padding: 8px 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-family: Lato, sans-serif;
    font-size: 13px;
    transition: color 0.18s ease, transform 0.18s ease;

    &:hover,
    &:focus-visible {
        color: ${({ theme }) => theme.palette.colors.text};
        transform: translateX(-3px);
    }
`;

export const BackLabel = styled.span``;

export const DetailHeader = styled.header`
    max-width: 900px;
    margin-bottom: clamp(42px, 6vw, 72px);
`;

export const Category = styled.div`
    margin-bottom: 16px;
    color: ${({ theme }) => theme.palette.blue.main};
    display: flex;
    align-items: center;
    gap: 9px;
`;

export const CategoryDot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme }) => theme.palette.blue.main};
`;

export const CategoryText = styled.span`
    font-family: Poppins, sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
`;

export const DetailTitle = styled.h1`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: clamp(40px, 6vw, 72px);
    font-weight: 700;
    letter-spacing: -0.05em;
    line-height: 0.98;
`;

export const DetailImage = styled.img`
    width: 100%;
    height: clamp(220px, 38vw, 460px);
    margin-bottom: clamp(42px, 6vw, 72px);
    border-radius: 18px;
    display: block;
    object-fit: cover;
`;

export const DetailLayout = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(220px, 280px);
    gap: clamp(44px, 8vw, 100px);
    align-items: start;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
        gap: 38px;
    }
`;

export const DetailBody = styled.div`
    min-width: 0;
`;

export const Paragraphs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Paragraph = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: clamp(17px, 2vw, 20px);
    line-height: 1.75;
    white-space: pre-wrap;
`;

export const DetailAside = styled.aside`
    min-height: 160px;
    padding-left: 28px;
    border-left: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    > .MuiButton-root {
        margin-top: 24px;
    }

    @media (max-width: 760px) {
        min-height: 0;
        padding: 28px 0 0;
        border-top: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
        border-left: 0;
    }
`;

export const DetailMeta = styled.time`
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Lato, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
`;

export const DetailMetaRelative = styled.div`
    color: ${({ theme }) => theme.palette.colors.subdued};
    font-family: Lato, sans-serif;
    font-size: 13px;
`;
